import React from 'react'
import OEIInput from './OEIInput';
import { EMPTY } from './Constants';
import { doNothing } from './OEIUtils';
export default function AccountLinkPopover(props) {
    const setAccountNumber = (e) => {
        props.setNewData({ ...props.newData, accountNumber: e });
        if (/^\d+$/.test(e)) {
            props.setErrors({ ...props.errors, error1: EMPTY })
        }
        else if (e === '') {
            props.setErrors({ ...props.errors, error1: EMPTY })
        } else {
            props.setErrors({ ...props.errors, error1: 'OE Central Account Numbers are made up of numbers only' })
        }
    }
    const setAccountName = (e) => {
        props.setNewData({ ...props.newData, accountName: e });
        props.setErrors({ ...props.errors, error2: EMPTY })
    }
    const openCentralMapping = (type, id) => {
        props.setMiddlePopoverName(type == 'edit' ? 'Edit System Mapping' : "New System Mapping");
        if (!type == 'edit') {
            props.setNewData({ ...props.newData, knovioCreationAccountId: EMPTY });
        }
        else {
            props.setNewData({ ...props.newData, knovioCreationAccountId: id });

        } props.setErrors({ ...props.errors, error6: EMPTY, error3: EMPTY, error4: EMPTY, error5: EMPTY })
    }
    const removeKnovioMapping = () => {
        props.setNewData({ ...props.newData, centralData: [] });
    }

    return (
        <>
            <>
                {props.popoverType === "manage" && props.type !== "New" ? <>
                    <OEIInput value={props.newData.accountName} readOnly='true' setValue={doNothing} newData={props.newData} name='accountNumber' errorMessage={props.errors.error2} label='Account Name' showError='false'></OEIInput>
                    <OEIInput value={props.newData.accountNumber} readOnly='true' setValue={doNothing} newData={props.newData} name='accountName' errorMessage={props.errors.error1} label='Account Number' showError='false'></OEIInput>
                </> :
                    <>
                        <OEIInput value={props.newData.accountName} setValue={setAccountName} newData={props.newData} name='accountNumber' errorMessage={props.errors.error2} label='Account Name' showError='false'></OEIInput>
                        <OEIInput value={props.newData.accountNumber} setValue={setAccountNumber} newData={props.newData} name='accountName' errorMessage={props.errors.error1} label='Account Number' showError='false'></OEIInput>
                    </>} {
                    props.type === "New" || props.popoverType === "manage" ?
                        <div class="oe-form-field ">
                            <label style={{color:'#1A1A1A', paddingLeft: '0px', display: 'flex', justifyContent: 'normal' }} class="attendee-list__label event_form__items-section__title" >
                                <span style={{ paddingRight: '104px' }}>Mapping</span>
                                {props.type !== "New" ? <></> : <span class="secondLabel">Account ID</span>}

                            </label>
                            {
                                props.newData.centralData && props.newData.centralData.map((item) => (
                                    <div class={`${props.middlePopoverName !== "Edit System Mapping" ? "email_row" : "email_row-selected email_row"}`}>
                                        <div style={{ width: '120px' }} class="m overflow-ellipsis">{'Knovio'}</div>
                                        <div class="m overflow-ellipsis">{item.knovioCreationAccountId}</div>
                                        <button type="button" onClick={() => openCentralMapping('edit', item.knovioCreationAccountId)} class="default-button default-button--slim-edit default-button--link visible-while-hovered">
                                            <span class="">{props.popoverType === "manage" && props.type !== "New" ? "Edit" : ""}</span></button>
                                        <button type='button' onClick={removeKnovioMapping} style={{ color: "#ff0000" }} class="default-button default-button--slim-edit default-button--link visible-while-hovered email-remove-label"><span>{props.popoverType === "manage" && props.type !== "New" ? "Remove" : ""}</span></button>
                                    </div>
                                ))}
                            <div class="m"><button type="button" class={`${props.middlePopoverName !== "New System Mapping" ? "email-new" : "email-new email-new-selected"}`} style={{ cursor: 'pointer' }} onClick={() => { openCentralMapping() }}><span >+ OE System mapping</span></button>  </div>
                            <div className="oe-form-field__error">{props.errors.error3}</div>

                        </div> : <></>
                }</>
        </>
    )
}
